import jwtDecode from 'jwt-decode';
import { NavLink } from 'react-router-dom';
import SpanBr from '../app/components/SpanBr';
import * as label from '../autobuild_version';
import MenuEl from '../models/MenuEl';
import MenuItem from '../models/MenuItem';
import UISize from '../models/UISize';
import { tabCommunication } from './TabCommunicationService';

export default class Utils {
  //
  static C_ENV_DEV = 'development';
  static C_ENV_TEST = 'test';
  static C_ENV_PROD = 'production';
  static C_ENV_UTV = 'utv';
  static _I = 0;


  /**
     * Helper method for development-only logging
     */
  static log(...args: any[]): void {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'vm') {
      console.log(...args);
    }
  }

  /**
    * Helper method for development-only logging
    */
  static warn(...args: any[]): void {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'vm') {
      console.warn(...args);
    }
  }

  /**
    * Helper method for development-only logging
    */
  static error(...args: any[]): void {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'vm') {
      console.error(...args);
    }
  }


  /*************************************************************************************** */
  /*************************************************************************************** */
  /*************************************************************************************** */
  /*                    LOG AND DISPLAY INFO DURING DEVELOPMENT                            */

  static IS_ENV_DEV(isDebugEnabled = false) {
    return Utils.getEnv.toString() === 'development' && isDebugEnabled;
  }

  /*************************************************************************************** */
  /*************************************************************************************** */
  /*************************************************************************************** */


  static CURRENT_BREAKPOINT(innerWidth: number) {
    switch (true) {
      case innerWidth > -1 && innerWidth <= 801:
        return 'xss';
      case innerWidth > 801 && innerWidth <= 1367:
        return 'xs';
      case innerWidth > 1367 && innerWidth <= 1681:
        return 'sm';
      case innerWidth > 1681 && innerWidth < 1921:
        return 'md';
      case innerWidth > 1921 && innerWidth < 2561:
        return 'lg';
      case innerWidth > 2561 && innerWidth < 3841:
        return 'xl';
      case innerWidth > 3841:
        return 'xxl';
      default:
        return 'md';
    }
  }

  static get HOST_NAME() {
    return window.location.hostname; // '/autodata-web-test' //packageJson.homepage;
  }

  static get WEBSOCKET_ADDRESS() {
    return import.meta.env.VITE_WEBSOCKET; // '/autodata-web-test' //packageJson.homepage;
  }


  static get AUTO_LOGOUT_TIME() {
    return import.meta.env.VITE_AUTO_LOGOUT_TIME; // '/autodata-web-test' //packageJson.homepage;
  }

  static get HOMEPAGE_CONTEXT() {
    return import.meta.env.BASE_URL?.replace(/\/$/, '') || ''; // '/autodata-web-test' //packageJson.homepage;
  }

  static get VERSION() {
    return label.version;
  }

  static get T_hauth() {
    const token = sessionStorage.getItem('token');
    return (jwtDecode(token || '') as any)._log;
  }

  static get T_tabId() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).tabId.toString() : undefined;
  }

  static get T_apiVersion() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).apiVersion.toString() : '';
  }

  static get isTabletAndroid() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).tablet.toString() === 'android' ? true : false : false;
  }

  static get isTabletIpad() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).tablet.toString() === 'ipad' ? true : false : false;
  }

  static get isDesktop() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).tablet.toString() === 'pc' ? true : false : false;
  }

  static get T_parentId() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).parent.toString() : undefined;
  }

  static get T_cn() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).cn.toString() : undefined;
  }

  static get T_name() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).firstName.toString() + ' ' + (jwtDecode(token || '') as any).lastName.toString() : undefined;
  }

  static get T_email() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).email.toString() : undefined;
  }

  static get T_mobile() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).mobil.toString() : undefined;
  }

  static get T_displayName() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).displayName.toString() : undefined;
  }
  static get T_company() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).CompanyName.toString() : undefined;
  }

  static get T_companyNr() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).Department.toString() : undefined;
  }

  static get T_groups() {
    const token = sessionStorage.getItem('token');
    return token ? (jwtDecode(token || '') as any).Groups.toString() : undefined;
  }

  static get APP_TITLE() {
    return 'Vitec Autodata Web';
  }

  static get HEIRLOOM_SERVICE() {
    return import.meta.env.VITE_H_SERVICE;
  }

  static get JAVA_API_SERVICE() {
    return import.meta.env.VITE_J_SERVICE;
  }

  static get DOTNET_SERVICE() {
    return import.meta.env.VITE_C_SERVICE;
  }

  static get DOTNET_DEV_SERVICE() {
    return import.meta.env.VITE_F_SERVICE;
  }

  static get URL_ADDRESS() {
    return import.meta.env.VITE_NODEJS_PROXY;
  }

  static get NODE_ENV_TYPE() {
    return Utils.getEnv;
  }

  static get GET_LINK_GW() {
    return import.meta.env.VITE_LINK_GW;
  }

  // Return a static incrementation of I accessible from the whole app.
  static get I() {
    return Utils._I++;
  }
  // ENV
  static get getEnv() {
    const mode = import.meta.env.MODE;
    switch (mode) {
      case Utils.C_ENV_PROD:
      case 'prod':
        return Utils.C_ENV_PROD;
      case Utils.C_ENV_TEST:
      case 'test':
        return Utils.C_ENV_TEST;
      case Utils.C_ENV_DEV:
      case 'dev':
      case 'vm':
        return Utils.C_ENV_DEV;
      default:
        return Utils.C_ENV_UTV;
    }
  }

  // Fabrice - Temporary FLAT built-up - Awaiting for a proper API Json object
  static assembleMenuItemList = (menuItems: MenuItem[]) => {
    const uniqueItems: string[] = [];
    const menuTree: MenuEl[] = [];
    if (menuItems.length > 0) {
      menuItems.forEach((item: MenuItem) => {
        if (!uniqueItems.includes(item.item)) {
          uniqueItems.push(item.item);
          if (item.subitem !== '') {
            menuTree.push(new MenuEl(item.item, item.role, '', item.item, item.heading, item.code
              , item.tilpasset, item.prodSynlig, item.kodeSynlig, item.labelSynlig, item.menuSynlig, item.name, [], true));
          }
          else {
            menuTree.push(
              new MenuEl(item.item, item.role, item.item, item.item, '', item.code, item.tilpasset, item.prodSynlig
                , item.kodeSynlig, item.labelSynlig, item.menuSynlig, item.name, [
                new MenuEl(item.item, item.role, item.item, item.item, item.heading, item.code, item.tilpasset
                  , item.prodSynlig, item.kodeSynlig, item.labelSynlig, item.menuSynlig, item.name, [
                  new MenuEl(item.item, item.role, item.item, item.item, item.heading, item.code, item.tilpasset
                    , item.prodSynlig, item.kodeSynlig, item.labelSynlig, item.menuSynlig, item.name, []),
                ]),
              ])
            );
          }

        }

        if (item.subitem === '') {
          const bob: MenuEl = menuTree.filter((obj: MenuEl) => {
            return obj.name === item.item;
          })[0];
          bob.nodes[0].nodes[0].nodes.push(new MenuEl(item.name, item.role, '', item.item, item.heading, item.code
            , item.tilpasset, item.prodSynlig, item.kodeSynlig, item.labelSynlig, item.menuSynlig, item.name));
        }
      });

      // Conditions when there are no subItem / nodes

      const uniqueSubItems: string[] = [];
      menuItems.forEach((subItem: MenuItem) => {
        if (!uniqueSubItems.includes(subItem.subitem)) {
          if (subItem.subitem !== '') {
            uniqueSubItems.push(subItem.subitem);
            let rootName = '';
            menuTree
              .filter((obj: MenuEl) => {
                if (obj.name === subItem.item) rootName = obj.rootName;
                return obj.name === subItem.item;
              })[0]
              .nodes.push(new MenuEl(subItem.subitem, subItem.role, subItem.item, rootName, subItem.heading, subItem.code
                , subItem.tilpasset, subItem.prodSynlig, subItem.kodeSynlig, subItem.labelSynlig, subItem.menuSynlig, subItem.name));
            const uniqueHeading: string[] = [];
            menuItems.forEach((el) => {
              if (el.item === subItem.item && el.subitem === subItem.subitem && !uniqueHeading.includes(el.heading)) {
                uniqueHeading.push(el.heading);
                menuTree
                  .filter((obj: MenuEl) => {
                    return obj.name === el.item;
                  })[0]
                  .nodes.filter((obi: MenuEl) => {
                    return obi.name === subItem.subitem;
                  })[0]
                  .nodes.push(new MenuEl(el.heading, el.role, subItem.subitem, rootName, el.heading, el.code, el.tilpasset, el.prodSynlig
                    , el.kodeSynlig, el.labelSynlig, el.menuSynlig, el.name));
              }
            });
          }
        }
      });
      //
      menuItems.forEach((item: MenuItem) => {
        const selectLevel2 = menuTree
          .filter((obj: MenuEl) => {
            return obj.name === item.item;
          })[0]
          .nodes.filter((obi: MenuEl) => {
            return obi.name === item.subitem;
          })[0];
        // 
        if (selectLevel2) { //TODO: parameterize this online.vitecauto.no
          const isProd = Utils.HOST_NAME === 'online.vitecauto.no';
          const shouldProcess = (!isProd) || (isProd && item.prodSynlig == 1);
          // Add the item to the menu tree if it is not already present
          if (shouldProcess) {
            let rootName = '';
            const matchingNode = selectLevel2.nodes.filter((obc: MenuEl) => {
              if (obc.heading === item.heading) rootName = obc.rootName;
              return obc.heading === item.heading;
            })[0];
            //
            matchingNode.nodes.push(
              new MenuEl(
                item.heading,
                item.role,
                item.subitem,
                rootName,
                item.heading,
                item.code,
                item.tilpasset,
                item.prodSynlig,
                item.kodeSynlig,
                item.labelSynlig,
                item.menuSynlig,
                item.name
              )
            );
          }
        }
      });
    }
    return menuTree;
  };

  static getTransactionsRole(menuItems: MenuEl[], val: string) {
    let role: any = undefined;
    if (menuItems && menuItems.length > 0) {
      menuItems.forEach((item: MenuEl) => {
        item.nodes.forEach((subItem: MenuEl) => {
          subItem.nodes.forEach((last: MenuEl) => {
            last.nodes.forEach((lst: MenuEl) => {
              if (lst.code === val) {
                role = lst.role;
              }
            });
          });
        });
      });
    }
    return role;
  }


  static getTransactionsMenuItem(menuItems: MenuEl[], val: string) {
    let mwe: any = {}
    menuItems.forEach((item: MenuEl) => {
      item.nodes.forEach((subItem: MenuEl) => {
        subItem.nodes.forEach((last: MenuEl) => {
          last.nodes.forEach((lst: MenuEl) => {
            if (lst.code === val) {
              mwe = lst;
            }
          });
        });
      });
    });
    return mwe;
  }

  // ENV
  static getFormattedDate(date: Date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  }

  static getTimeStamp() {
    const now = new Date();
    const date = now.toLocaleDateString('nb-NO'); // Norwegian date format (dd.mm.yyyy)
    const time = now.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // HH:MM:SS
    return `${date} ${time}`;
  }

  static get devAddon() {
    if (Utils.IS_ENV_DEV(true)) {
      return (
        <span>
          <a href={Utils.HEIRLOOM_SERVICE + '/menu.html'}>menu.html</a>
        </span>
      );
    }
    return null;
  }

  // REDUCER update store
  static updateStore = (oldObject: any, updatedProperties: any) => {
    return {
      ...oldObject,
      ...updatedProperties,
    };
  };

  /*
   * Mockup
   *
   */
  static feedBackTextElement = (val: string) => {
    // Lookup for msg sent from API
    switch (true) {
      case val.indexOf('token_expired') !== -1:
        return [
          <SpanBr key="fb0">
            Token er ugyldig. Få tilsendt en ny ved å trykke på denne
            <br />
            <br />
            <NavLink to={Utils.HEIRLOOM_SERVICE + '/passwordlinkrecovery'}>Linken</NavLink>
            <br />
          </SpanBr>,
        ];

      case val.indexOf('invalid_token') !== -1:
        return [
          <SpanBr key="fb0">
            Token er ugyldig. Få tilsendt en ny ved å trykke på denne
            <br />
            <br />
            <NavLink to={Utils.HEIRLOOM_SERVICE + '/passwordlinkrecovery'}>Linken</NavLink>
            <br />
          </SpanBr>,
        ];

      case val.indexOf('not_authorized') !== -1:
        return [
          <SpanBr key="fb0">
            En feil oppstod ved endring av passord!
            <br />
            Du er ikke autorisert for å endre passordet på brukerenIkke autorisert.
          </SpanBr>,
        ];

      case val.indexOf('error code 53') !== -1:
        return [
          <SpanBr key="fb0">
            En feil oppstod ved endring av passord!
            <br />
            Passordet oppfyller ikke passordpolicyen.
          </SpanBr>,
        ];

      case val.indexOf('pass_updated') !== -1:
        return [<SpanBr key="fb0">Passordet har blitt oppdatert!</SpanBr>];

      case val.indexOf('user_mot_found') !== -1:
        return [<SpanBr key="fb0">Bruker ikke funnet.</SpanBr>];

      default:
        return [<SpanBr key="fb1" text={val.toString()} />];
    }
  };

  /*
   * Build a Json Obj from and URL query
   *
   */

  static getJsonFromUrl = (url: string) => {
    const query = url.substr(1);
    const result: { [key: string]: string } = {};
    query.split('&').forEach(function (part) {
      const item = part.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  };

  // DEPRECATED: Use TabCommunicationService directly instead of this method
  // Use local storage for messaging. Set message in local storage and clear it right away
  // This is a safe way how to communicate with other tabs while not leaving any traces
  static message_broadcast(message: any, delay = 0) {
    // Use the imported tabCommunication service
    tabCommunication.broadcast(message, delay);
  }

  // 
  static getWindowDimensions() {
    const { innerWidth: width, innerHeight: height, pageYOffset } = window; // Utils.log(new UISize(width, height), ' dim: ');
    return new UISize(width, height, pageYOffset);
  }

  // Get the location path from the menu item
  static getLocationPathFromMenuEl(menuEl: MenuEl) {
    return <div style={{ display: 'flex', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {menuEl.rootName} {menuEl.parentName ? ' > ' + menuEl.parentName : null}
      {menuEl.parentName !== menuEl.name ? ' > ' + this.shortegingText(menuEl.name, 80) : null}
      {menuEl.name !== menuEl.description ? ' > ' + this.shortegingText(menuEl.description, 40) : null}
      {/*this.shortegingText(menuEl.description, 60)*/}
    </div>;
  }


  // Get the location path from the selected menu item
  static getLocationPathFromSelected(selectedMemy: any) {
    // Remove selectedMemy[0] from selectedMemy[1] if selectedMemy[1] exists
    const modifiedSelectedMemy1 = selectedMemy[1] ? selectedMemy[1].replace(selectedMemy[0], '').trim() : '';
    return (
      <div style={{ display: 'flex', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {selectedMemy[0] ? this.shortegingText(selectedMemy[0]) : ''}
        {modifiedSelectedMemy1 ? ' > ' + modifiedSelectedMemy1 : ''}
      </div>
    );
  }


  //
  static shortegingText(value: string, _max = 50) {
    return value.length > _max ? value.substring(0, _max) + '...' : value;
  }


  // Utils to limit repetitions
  static debounce(func: (...args: any[]) => void, ms = 50) {
    let timer: any;
    return function (event: any) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, ms, event);
    };
  }

  // TODO TEST - Utils to limit repetitions
  static debounce_new(func: (...args: any[]) => void, ms = 50) {
    let timer: any;
    return function (event: any) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => func(event), ms);
    };
  }

  static isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  static isAModalCall(val = '') {
    return val.includes('htmlMsg=');
  }

  static ldapToJS(n: number) {
    // Longer, equivalent to short version
    // return new Date(n/1e4 + new Date(Date.UTC(1601,0,1)).getTime());
    // Shorter, more efficient. Uses time value for 1601-01-01 UTC
    return new Date(n / 1e4 - 1.16444736e13);
  }

  static compareByNameFilter(a: any, b: any) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  static getTextSelection(el: any) {
    let start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;
    //
    if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = (document as any).selection.createRange();

      if (range && range.parentElement() === el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, '\n');

        // Create a working TextRange that lives only in the input
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());

        // Check if the start and end of the selection are at the very end
        // of the input, since moveStart/moveEnd doesn't return what we want
        // in those cases
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart('character', -len);
          start += normalizedValue.slice(0, start).split('\n').length - 1;

          if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd('character', -len);
            end += normalizedValue.slice(0, end).split('\n').length - 1;
          }
        }
      }
    }
    return { start, end };
  }

  static preventDefault(e: Event) {
    e.preventDefault();
  }

  static giveFocusToSearchField() {
    // CTRL + S
    document.getElementById('code-select')?.focus();
  }

  static removeFocusToSearchField() {
    document.getElementById('code-select')?.blur();
  }

  static desc(a: any, b: any, orderBy: string) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  static asc(a: any, b: any, orderBy: string) {
    if (b[orderBy] > a[orderBy]) {
      return -1;
    }
    if (b[orderBy] < a[orderBy]) {
      return 1;
    }
    return 0;
  }

  static stableSort(array: any[] | undefined | null, cmp: (a: any, b: any) => number) {
    const safeArray = Array.isArray(array) ? array : [];
    const stabilizedThis = safeArray.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  static formatNumber = (num: number): string => {
    const formattedAmount = Math.floor(num).toLocaleString('no-NO', {});
    return formattedAmount.replace(/\s/g, '.');
  };



  static getSorting(order: string, orderBy: string) {
    switch (true) {
      case order === "desc":
        return order === "desc"
          ? (a: any, b: any) => Utils.desc(a, b, orderBy)
          : (a: any, b: any) => -Utils.desc(a, b, orderBy);
      case order === "asc":
        return order === "asc"
          ? (a: any, b: any) => Utils.asc(a, b, orderBy)
          : (a: any, b: any) => - Utils.asc(a, b, orderBy);
      default:
        return order === "asc"
          ? (a: any, b: any) => Utils.asc(a, b, orderBy)
          : (a: any, b: any) => - Utils.asc(a, b, orderBy);
    }
  }


  static formatter(val: any) {
    const value = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: "code",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(val).replace('EUR', '');
    return value.substring(0, value.length - 1);
  }


  // takes a value and adds decimal formatting without currency symbol
  static decimalformatter(val: any) {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    const value = new Intl.NumberFormat('nb-NO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
    return value;
  }



  static getPercentAB(numA: any, numB: any) {
    let perCent = 0.0;
    //
    if (numB < 0 && numA > 0) {
      perCent = (numA + (numB * -1)) / numB * 100;
      // perCent = (numA - numB) / numA * 100;
    } else if (numA < 0 && numB > 0) {
      perCent = (numB + (numA * -1)) / numA * 100;
      // perCent = (numA - numB) / numA * 100;
    } else if (numA > numB) {
      perCent = (numA - numB) / numA * 100;
    } else
      perCent = (numA - numB) / numB * 100;
    //
    return Math.round(perCent * 100) / 100;
  }

  static getLastFourCharactersFromURL = (): string | null => {
    // Get the current URL
    const loc: string = window.location.href;

    // Remove the leading '?' if present
    const query = loc.startsWith('?') ? loc.slice(1) : loc;

    // Split the query string into individual parameters
    const params = query.split('&');

    // Find the last '/' or '=' in the parameter
    for (const param of params) {
      // Find the last '/' or '=' in the parameter
      const lastSlashIndex = param.lastIndexOf('/');
      const lastEqualIndex = param.lastIndexOf('=');
      const lastIndex = Math.max(lastSlashIndex, lastEqualIndex);
      // If the last '/' or '=' is found, return the last four characters
      //if (lastIndex !== -1 && param.length > lastIndex + 4) {
      //  return param.slice(lastIndex + 1, lastIndex + 5);
      //}

      if (lastIndex !== -1 && param.length > lastIndex + 4) {
        const lastFourChars = param.slice(lastIndex + 1, lastIndex + 5);
        if (lastFourChars !== 'home' && lastFourChars !== 'menu') {
          return lastFourChars;
        }
      }
    }

    return null;
  };

  /**
   * Converts two-digit year strings to full four-digit years with proper century logic
   * 
   * Handles year conversion with the following rules:
   * - Years 00-34: Converted to 20xx (2000-2034)
   * - Years 35-99: Converted to 19xx (1935-1999)
   * - Single digit years (0-9): Padded with leading zero then converted
   * - Already four-digit years: Returned unchanged
   * 
   * @param {string} year - The year string to convert (can be 1-4 digits)
   * @returns {string} Four-digit year string
   * 
   * @example
   * getfullYearDataFromTwoDigitedYear("5")    // returns "2005"
   * getfullYearDataFromTwoDigitedYear("25")   // returns "2025" 
   * getfullYearDataFromTwoDigitedYear("50")   // returns "1950"
   * getfullYearDataFromTwoDigitedYear("2023") // returns "2023"
   */
  static getfullYearDataFromTwoDigitedYear = (year: string): string => {
    // Handle single digit years (0-9) by adding leading zero
    if (/^\d{1}$/.test(year)) {
      year = '0' + year;
    }

    // Check if the year is now a two-digit number
    if (/^\d{2}$/.test(year)) {
      const yearNumber = parseInt(year, 10);
      // If year is less than 32, use 20xx, otherwise use 19xx
      const fullYear = yearNumber < 32 ? 2000 + yearNumber : 1900 + yearNumber;
      return fullYear.toString();
    }

    // Return unchanged if already 3+ digits or not a valid number
    return year;
  };
}

export function debounce(func: any, wait: number, immediate: boolean) {
  let timeout: number | undefined;

  return function executedFunction(_this: any) {
    const context: any = _this;
    const args = arguments; // eslint-disable-line
    const later = () => {
      timeout = undefined;
      if (!immediate) {
        func.apply(context, [args]);
      }
    };
    const callNow: boolean = immediate && !timeout;
    clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) {
      func.apply(context, [args]);
    }
  };
}

export function throttle(fn: any, wait: number) {
  let shouldWait = false;

  return function () {
    if (!shouldWait) {
      fn([arguments]); // eslint-disable-line
      shouldWait = true;
      setTimeout(() => (shouldWait = false), wait);
    }
  };
}
